import { seatCampaignStatusValueLabels } from './value-labels.js';
export const seatCampaignsCube = {
    category: 'Recruitment',
    description: 'Application campaigns with open seat counts, application totals, and appointment metrics.',
    label: 'Application Campaigns',
    requiredModule: 'hasTenure',
    measures: {
        'seat_campaigns.count': { label: 'Count', type: 'number' },
        'seat_campaigns.total_applications': { label: 'Total Applications', type: 'number' },
        'seat_campaigns.appointments_made': { label: 'Appointments Made', type: 'number' },
        'seat_campaigns.applications_per_seat': { label: 'Applications Per Seat', type: 'number' },
    },
    dimensions: {
        'seat_campaigns.description': { label: 'Description', narrative: true, type: 'string' },
        'seat_campaigns.name': { label: 'Name', type: 'string' },
        'seat_campaigns.status': {
            label: 'Status',
            type: 'string',
            valueLabels: seatCampaignStatusValueLabels,
        },
        'seat_campaigns.total_open_seats': { label: 'Total Open Seats', type: 'number' },
    },
    timeDimensions: {
        'seat_campaigns.created_at': { label: 'Created At', type: 'date' },
        'seat_campaigns.end_date': { label: 'End Date', type: 'date' },
        'seat_campaigns.start_date': { label: 'Start Date', type: 'date' },
        'seat_campaigns.submission_deadline': { label: 'Submission Deadline', type: 'date' },
        'seat_campaigns.updated_at': { label: 'Updated At', type: 'date' },
    },
};
